/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';

var sanitizeId = function sanitizeId(id, iconId) {
  return "".concat(id, "--").concat(iconId);
};
var sanitizeIds = function sanitizeIds(ids, iconId) {
  return ids.reduce(function (randomizedIds, id) {
    return _objectSpread2(_objectSpread2({}, randomizedIds), {}, _defineProperty({}, id, sanitizeId(id, iconId)));
  }, {});
};
var sanitizeIds$1 = sanitizeIds;

export { sanitizeIds$1 as default };
